import { useEffect } from 'react';
import logger from '../../utils/logger';

const PerformanceMonitor = () => {
  useEffect(() => {
    // Only run in development
    if (process.env.NODE_ENV !== 'development') return;

    let renderCount = 0;
    const componentRenders = new Map();

    // Monkey patch React to track renders (only if React is on window)
    if (!window.React || !window.React.createElement) return;

    const originalCreateElement = window.React.createElement;
    window.React.createElement = function(...args) {
      const [type] = args;
      if (typeof type === 'function' && type.name) {
        const count = componentRenders.get(type.name) || 0;
        componentRenders.set(type.name, count + 1);
        renderCount++;

        // Log excessive renders
        if (count > 0 && count % 10 === 0) {
          logger.warn(`⚠️ Component ${type.name} has rendered ${count} times`);
        }
      }
      return originalCreateElement.apply(this, args);
    };

    // Log performance metrics every 30 seconds
    const interval = setInterval(() => {
      if (renderCount > 0) {
        logger.log('📊 Performance Report:');
        logger.log(`Total renders: ${renderCount}`);

        // Show top rendering components
        const sorted = Array.from(componentRenders.entries())
          .sort((a, b) => b[1] - a[1])
          .slice(0, 5);

        logger.log('Top rendering components:');
        sorted.forEach(([name, count]) => {
          logger.log(`  ${name}: ${count} renders`);
        });

        // Reset counter
        renderCount = 0;
        componentRenders.clear();
      }
    }, 30000);

    return () => {
      clearInterval(interval);
      window.React.createElement = originalCreateElement;
    };
  }, []);

  return null;
};

export default PerformanceMonitor;